module.exports = __webpack_public_path__ + "static/media/sw-logo-white.6a5c384b.svg";